import React from 'react';
import './SmallTextCards.css';
import Card from 'react-bootstrap/Card';

const SmallTextCards = ({ header, text, variant }) => {
  console.log(variant)
  const contentStyle = {
    backgroundColor: variant,
    minHeight: "450px",
    minWidth: "150px",
    padding: "2px"
  };
  return (

    <Card     
    style={contentStyle}

    key={variant}
    text={variant.toLowerCase() === 'light' ? 'dark' : 'white'} >
    <Card.Body>
      <Card.Title>{header}</Card.Title>
      <Card.Text>
      {text}
      </Card.Text>
    </Card.Body>
  </Card>
  );
};

export default SmallTextCards;
